<template>
  <div class="clear-filters-wrapper">
    <a :href="getUrlNoFilters" class="clear-filters-button"><span>{{ t('filters.clear.all') }}</span></a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TagListingFiltersModel from './tag/filters/Models/TagListingFiltersModel'

export default {
  name: 'AdvListingClearFiltersMobile',
  props: {
    group: {
      tagDisplayType: '',
      tagGroupId: '',
      tagGroupName: null,
      tagGroupStep: 0,
      tagGroupDisplayPosition: 0,
      tags: []
    },
    tag: {
      tagDisplayValue: '',
      tagId: '',
      tagName: ''
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'getActiveTagFilters',
      'getTagRecordsUsed',
      'getFilterQueryStringVar',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getCurrentPageNumber',
      'getActiveVariationFiltersString',
      'getActiveAttributeFiltersString',
      'config',
      'getUrlNoFilters'
    ]),
    builtQueryString () {
      return this.filteringManage(this.group, this.tag)
    },
    activeFiltersString () {
      const variationFiltersString = this.getActiveVariationFiltersString
      const attributeFiltersString = this.getActiveAttributeFiltersString
      if (variationFiltersString !== '' && attributeFiltersString !== '') {
        return variationFiltersString + '&' + attributeFiltersString
      }
      if (variationFiltersString !== '') {
        return variationFiltersString
      }
      if (attributeFiltersString !== '') {
        return attributeFiltersString
      }
      return ''
    }
  },
  methods: {
    filteringManage (group, entry) {
      const isFilterUsed = true
      const duplicateAttributeGroupNamesPerGroup = {}
      return new TagListingFiltersModel(
        this.getUriWithoutOffset,
        this.getFilterQueryStringVar,
        this.getActiveTagFilters,
        this.getIsTopLevelCategory,
        this.getCurrentPageNumber,
        this.config.url.lang,
        this.activeFiltersString,
        duplicateAttributeGroupNamesPerGroup
      ).createLinkQueryStringFinal(group, entry, isFilterUsed)
    }
  }
}
</script>

<style lang="scss" scoped>
.clear-filters-wrapper{
  position: relative;
  width: 100%;
  display: grid;
  margin: 0;
  border: 1px solid #707070;
  border-radius: 8px;
  font-size: 14px;
  padding: 0 10px;
  line-height: 1.2;
  font-weight: 500;
  height: 40px;
  align-items: center;
  @media screen and (max-width: 991px) {
    width: max-content;
    padding: 0;
    font-size: 13px;
  }
  .clear-filters-button{
    background: transparent;
    color: #FF0000;
  }
  @media screen and (min-width: 992px) {
    display: none;
  }
}
</style>
